module.exports = require('./umd/embedded.development.js'); // eslint-disable-line global-require



//////////////////
// WEBPACK FOOTER
// ./node_modules/hellosign-embedded/index.js
// module id = 1782
// module chunks = 0